import { captureException } from 'src/common/sentry-client'

export default ({ app }) => {
  app.config.errorHandler = (err, instance, info) => {
    const tags = {
      'vue.info': info,
    }
    if (instance?.$options.__name) {
      tags['vue.component'] = instance.$options.__name
    }

    captureException(err, {
      tags,
      extras: {
        props: instance?.$props,
        data: instance?.$data,
      },
    })

    if (import.meta.env.DEV) {
      console.error('Vue error:', err, info)
    }
  }
}
